export interface ICards {
    id: string;
    drawingPointId: string;
    accountId: string;
    drawingPointNumber: string;
    accountNumber: string;
    vrn: string;
    driverName: string;
    purchaseCode: string;
    cardNumber: string;
    //custom property
    selected: boolean;
}

export class CardTranLiveCardModel {
    //EndPointURL: string;
    Token: string;
    AccountId: string[];
}

export interface IDrawingAccounts {
    id: string;
    accountId: string;
    number: string;
    name: string;
    defaultPinNumber: string;
    defaultPurchaseOption: string;
    isDefaultDrawingPoint: true;
}

export class CardTranDrawingPointModel {
   // EndPointURL: string;
    Token: string;
    AccountId: string[];
}

export interface IDrawings {

    id: string;
    drawnDate: Date;
    accountNumber: string;
    subAccountNumber: string;
    cardNumber: string;
    shortCardNumber: string;
    driverName: string;
    registration: string;
    vrnSite: string;
    odometer: number;
    siteName: string;
    sitePostCode: string;
    product: string;
    invoiceNumber: string;
    quantity: number;
    price: number;
    estimatedPrice: number;
    companyName: string;
    costCenter: string;
    driverDescription: string;
    invoiceDate: Date;
    transactionNumber: string;
    ledgerName: string;
    ledgerNumber: string;
    isBunkered: string;
    ghg: number;
    cO2: number
    cH4: number;
    n2O: number;
}

export class CardTranDrawingModel {
    //EndPointURL: string;
    Token: string;
    AccountId: string[];
    UserName: string;
    referenceNumber: string;
    UserId: string;
    QueryValue: string;
}

export interface ICO2 {

    id: string;
    drawnDate: Date;
    accountNumber: string;
    subAccountNumber: string;
    cardNumber: string;
    shortCardNumber: string;
    driverName: string;
    registration: string;
    vrnSite: string;
    odometer: number;
    siteName: string;
    sitePostCode: string;
    product: string;
    invoiceNumber: string;
    quantity: number;
    price: number;
    estimatedPrice: number;
    companyName: string;
    costCenter: string;
    driverDescription: string;
    invoiceDate: Date;
    transactionNumber: string;
    ledgerName: string;
    ledgerNumber: string;
    isBunkered: true;
    ghg: number;
    cO2: number
}

export class CO2Model {
   // EndPointURL: string;
    Token: string;
    AccountId: string[];
}

export class DrawingsDataTablesResponse {
    data: IDrawings[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
    referenceNumber: string;
    error: string;
}

export class AcceptedResponse {
    statuscode: string;
    referenceNumber: string;
    error: string;
    location: string;
    retryafter: number;
}



// WEBPACK FOOTER //
// ./src/app/cardtransaction/cardtransaction.ts